// extracted by mini-css-extract-plugin
export default {"homeTilesSection":"mainMenuTiles_homeTilesSection__03Wd-","icon":"mainMenuTiles_icon__rA49r","homeTilesHeaderContainer":"mainMenuTiles_homeTilesHeaderContainer__Ulmut"};